import { createFileRoute } from "@tanstack/react-router"
import { requirePermission } from "@/lib/require-permission"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/teams",
)({
  staticData: {
    breadcrumb: [
      {
        label: "Workspace - Teams",
        href: "/settings/workspace/teams",
      },
    ],
  },
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(queryClient, "team:read", "/settings/workspace/general"),
})
